import { EnhancedStore, Dispatch } from '@reduxjs/toolkit';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { RTKInitialFuncComponent } from './RTKInitialFuncComponent';

export interface IRTKStoreProvider {
    children: React.ReactNode;
    /**
     * The redux toolkit store
     */
    store: EnhancedStore;
    /**
     * the component to be shown if the initFunc throw errors
     */
    error: React.ReactElement;
    /**
     * the component shown during initFunc execution
     */
    loading: React.ReactElement;
    /**
     * Usually a function to initialize the store datas
     */
    initFunc?: (dispatch: Dispatch) => Promise<any>;
}

export const RTKStoreProvider: React.FunctionComponent<IRTKStoreProvider> = ({
    children,
    error,
    loading,
    initFunc,
    store,
}) => {
    const [isLoading, setIsLoading] = useState(initFunc ? true : false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (initFunc) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
        setIsError(false);
    }, []);

    let renderComponent = children;

    if (isLoading) {
        renderComponent = loading;
    }

    if (isError) {
        renderComponent = error;
    }


    return (
        // https://github.com/facebook/react/issues/24304#issuecomment-1094565891
        <Provider store={store}>
            {initFunc && (
                <RTKInitialFuncComponent
                    setIsLoading={setIsLoading}
                    initFunction={initFunc}
                    setIsError={setIsError}
                />
            )}
            {renderComponent}
        </Provider>
    );
};
